import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VConsole from 'vconsole';

if(process.env.VUE_APP_ENV != "production") new VConsole()


// import { ElMessage } from 'element-plus';

window.$alert = (str) => {
    // ElMessage({
    //     offset: 700,
    //     message: str,
    //     type: 'warning'
    // })
}

axios.interceptors.response.use(response => {
    return response.data
})

const app = createApp(App)
app.use(ElementPlus).use(store).use(router).mount('#app')
